import { render, staticRenderFns } from "../configurations/configurations.html?vue&type=template&id=2529fd8e&scoped=true&external"
import script from "../configurations/configurations.js?vue&type=script&lang=js&external"
export * from "../configurations/configurations.js?vue&type=script&lang=js&external"
import style0 from "../configurations/configurations.css?vue&type=style&index=0&id=2529fd8e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529fd8e",
  null
  
)

export default component.exports